import { toast } from "react-toastify";

import {
  fetchUploadPublicRequest,
  fetchUploadPublicSuccess,
  fetchUploadPublicFailure,
} from "./reducer";

import { UPLOAD_PUBLIC_FILE } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

export const uploadPublicFile =
  (file, setLoading, onSuccess) => async (dispatch) => {
    dispatch(fetchUploadPublicRequest());

    setLoading?.(true);

    try {
      const formData = new FormData();

      formData.append("files", file);

      const response = await determineBaseUrlAndPerformApiCall(
        UPLOAD_PUBLIC_FILE,
        "POST",
        formData,
        false
      );

      console.log("UPLOAD API RESPONSE:", response);

      if (response?.error) {
        dispatch(
          fetchUploadPublicFailure(
            response.error.message || "File upload failed"
          )
        );

        toast.error(
          response.error.message || "File upload failed"
        );

        return;
      }

      dispatch(fetchUploadPublicSuccess(response));

      onSuccess?.(response);
    } catch (error) {
      console.error("UPLOAD API ERROR:", error);

      dispatch(
        fetchUploadPublicFailure("Something went wrong")
      );

      toast.error("Something went wrong");
    } finally {
      setLoading?.(false);
    }
  };